import React from 'react';
import { Title4, ListBasic, ListItemBasic, Link } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-internal/js-react-i18n';
import Classes from './SellLocations.module.scss';
import carsLocations from '../../../../../../content/carsContent/locations.json';

const SellLocations = () => {
  const { t } = useI18nContext();

  return (
    <section className={Classes.root}>
      <Title4 as="h6">{t('cars.sell.locations.title')}</Title4>
      <ListBasic className={Classes.LocationsList}>
        {carsLocations.map(({ slug, name }) => (
          <ListItemBasic key={slug}>
            <Link href={`/cp/91/auto-verkopen/${slug}/`}>{t('cars.sell.locations.label', { location: name })}</Link>
          </ListItemBasic>
        ))}
      </ListBasic>
    </section>
  );
};

export default SellLocations;
